import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';
import { List, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { removeNutMaterial, updateSts } from './NutMaterialSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';

export default function NutMaterialPageList(): JSX.Element {
  const dispatch = useDispatch();
  const { setModelChange, messageApi, setEditBodySize } = React.useContext(CommonContext) as CommonContextType;
  const NutMaterial = useSelector(
    (state: AppState) => state.NutMaterials
  );

  useEffect(() => {
    if (NutMaterial.success.sts == true) {
      messageApi.open({
        type: 'success',
        content: NutMaterial.success.data,
      });

      dispatch(updateSts({}));
    } else if (NutMaterial.success.sts == false) {
      messageApi.open({
        type: 'error',
        content: NutMaterial.success.data,
      });

      dispatch(updateSts({}));
    }

  }, [NutMaterial])

  const showModal = (record?: any) => {
    if (record.id) {
      setEditBodySize(record)
      setModelChange(true)
    }
  };
  const handleDelete = (id: number) => {
    dispatch(removeNutMaterial(id));
   /*  messageApi.open({
      type: 'success',
      content: 'Nut Material deleted successfully',
    }); */
  };
  return (
    <List
      className="demo-loadmore-list"
      itemLayout="horizontal"
      dataSource={NutMaterial.NutMaterial}
      renderItem={(item: any, index) => (
        <List.Item key={item.id}
          actions={[
            <EditOutlined style={{ color: '#018B98' }} onClick={() => showModal(item)} />,
            <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(item.id)}>
              <DeleteOutlined style={{ color: 'red' }} />
            </Popconfirm>]}>

          <div className='main_class'>
            <p className='sub_data'><b>Value:</b> {item.material_name} </p>
          </div>
        </List.Item>
      )}
    />
  );
}